export default "/images/outdoor_playtime_sm.jpg?8b48e6ce6bed12701e171b164031107a";